export const mapState = {
    selectCluster: null,
    container: null,
    content: null,
    closer: null,
    overlay: null,
    slideRight: null,
};
